import { AnyAction } from "redux";
import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IComplaintsState, initialComplaintsState } from "./complaints.state";
import {
    FETCH_COMPLAINT_LOG_LIST_PROGRESS,
    FETCH_COMPLAINT_LOG_LIST_SUCCESS,
    FETCH_COMPLAINT_LOG_LIST_FAILED,
    CLEAR_COMPLAINT_LOG_STATE,
    FETCH_COMPLAINT_BY_MECHANIC_BY_CITY_LIST_PROGRESS,
    FETCH_COMPLAINT_BY_MECHANIC_BY_CITY_LIST_SUCCESS,
    FETCH_COMPLAINT_BY_MECHANIC_BY_CITY_LIST_FAILED,
    CLEAR_COMPLAINT_BY_MECHANIC_BY_CITY_STATE,
    FETCH_COMPLAINT_REPORT_LIST_PROGRESS,
    FETCH_COMPLAINT_REPORT_LIST_SUCCESS,
    FETCH_COMPLAINT_REPORT_LIST_FAILED,
    CLEAR_COMPLAINT_REPORT_DETAILS_LIST_STATE,
} from "./complaints.action";

export const complaintsReducer = (
    state: IComplaintsState = initialComplaintsState,
    action: AnyAction
): IComplaintsState => {
    switch (action.type) {
        // ==================== COMPLAINT LOG REDUCERS ====================
        case FETCH_COMPLAINT_LOG_LIST_PROGRESS: {
            return produce(state, (draftState) => {
                draftState.complaintLog.list.loading = LoadState.InProgress;
                draftState.complaintLog.list.list = [];
                draftState.complaintLog.list.totalRecords = 0;
            });
        }
        case FETCH_COMPLAINT_LOG_LIST_SUCCESS: {
            const { list, totalRecords } = action.payload;
            return produce(state, (draftState) => {
                draftState.complaintLog.list.loading = LoadState.Loaded;
                draftState.complaintLog.list.list = list;
                draftState.complaintLog.list.totalRecords = totalRecords;
            });
        }
        case FETCH_COMPLAINT_LOG_LIST_FAILED: {
            return produce(state, (draftState) => {
                draftState.complaintLog.list.loading = LoadState.Failed;
                draftState.complaintLog.list.list = [];
                draftState.complaintLog.list.totalRecords = 0;
            });
        }
        case CLEAR_COMPLAINT_LOG_STATE: {
            return produce(state, (draftState) => {
                draftState.complaintLog = initialComplaintsState.complaintLog;
            });
        }

        // ==================== COMPLAINT BY MECHANIC BY CITY REDUCERS ====================
        case FETCH_COMPLAINT_BY_MECHANIC_BY_CITY_LIST_PROGRESS: {
            return produce(state, (draftState) => {
                draftState.complaintByMechanicByCity.list.loading = LoadState.InProgress;
                draftState.complaintByMechanicByCity.list.list = [];
                draftState.complaintByMechanicByCity.list.totalRecords = 0;
            });
        }
        case FETCH_COMPLAINT_BY_MECHANIC_BY_CITY_LIST_SUCCESS: {
            const { list, totalRecords } = action.payload;
            return produce(state, (draftState) => {
                draftState.complaintByMechanicByCity.list.loading = LoadState.Loaded;
                draftState.complaintByMechanicByCity.list.list = list;
                draftState.complaintByMechanicByCity.list.totalRecords = totalRecords;
            });
        }
        case FETCH_COMPLAINT_BY_MECHANIC_BY_CITY_LIST_FAILED: {
            return produce(state, (draftState) => {
                draftState.complaintByMechanicByCity.list.loading = LoadState.Failed;
                draftState.complaintByMechanicByCity.list.list = [];
                draftState.complaintByMechanicByCity.list.totalRecords = 0;
            });
        }
        case CLEAR_COMPLAINT_BY_MECHANIC_BY_CITY_STATE: {
            return produce(state, (draftState) => {
                draftState.complaintByMechanicByCity = initialComplaintsState.complaintByMechanicByCity;
            });
        }

        // ==================== COMPLAINT REPORT REDUCERS ====================
        case FETCH_COMPLAINT_REPORT_LIST_PROGRESS: {
            return produce(state, (draftState) => {
                draftState.complaintReportDetails.list.loading = LoadState.InProgress;
                draftState.complaintReportDetails.list.list = [];
                draftState.complaintReportDetails.list.totalRecords = 0;
            });
        }
        case FETCH_COMPLAINT_REPORT_LIST_SUCCESS: {
            const { list, totalRecords } = action.payload;
            return produce(state, (draftState) => {
                draftState.complaintReportDetails.list.loading = LoadState.Loaded;
                draftState.complaintReportDetails.list.list = list;
                draftState.complaintReportDetails.list.totalRecords = totalRecords;
            });
        }
        case FETCH_COMPLAINT_REPORT_LIST_FAILED: {
            return produce(state, (draftState) => {
                draftState.complaintReportDetails.list.loading = LoadState.Failed;
                draftState.complaintReportDetails.list.list = [];
                draftState.complaintReportDetails.list.totalRecords = 0;
            });
        }
        case CLEAR_COMPLAINT_REPORT_DETAILS_LIST_STATE: {
            return produce(state, (draftState) => {
                draftState.complaintReportDetails = initialComplaintsState.complaintReportDetails;
            });
        }

        default:
            return state;
    }
};
